// Author lidongxu
// Date 2024-01-16 15:13:20

class SithMesInventoryComprehensiveBusinessVendorAndSithInfo {
constructor({
        id = null,
        companyName = '',
        address = '',
        contact = '',
        contactPhone = '',
        remark = ''}
= {}) {
    this.id = id;
    this.companyName = companyName;
    this.address = address;
    this.contact = contact;
    this.contactPhone = contactPhone;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryComprehensiveBusinessVendorAndSithInfo();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'companyName',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.grid.companyName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'address',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.grid.address',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'contact',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.grid.contact',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'contactPhone',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.grid.contactPhone',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    companyNameFilter : '',
    addressFilter : '',
    contactFilter : '',
    contactPhoneFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'companyNameFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.filter.companyName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'addressFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.filter.address',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.filter.contact',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactPhoneFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.filter.contactPhone',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'companyName',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.entity.companyName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'address',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.entity.address',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contact',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.entity.contact',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactPhone',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.entity.contactPhone',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessVendorAndSithInfo.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesInventoryComprehensiveBusinessVendorAndSithInfo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
